import * as React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import toast from 'react-hot-toast';
import { postRequest } from '../../../../lib/api';
import { useContext } from 'react';
import { AuthContext } from '../../../../authContext/context';
import { useDispatch } from 'react-redux';
import { addTags } from '../../../../redux/slices/tagsSlice';
import BreadcrumbsWrapper from '../../../../components/breadcrumbs'

export default function CreateTags() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      type: 'Group Code',
    },
  });

  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const payload = {
        name: data?.name,
        type: data?.type,
      };

      const response = await postRequest('private/createTags', payload, authCtx.token);
      console.log(response, 'response');

      if (response?.status == 200) {
        //toast.success('Tag created successfully!');
        dispatch(addTags(response?.data));
        reset();
        navigate('/tags');
      } else {
        //toast.error(response?.message || 'Tag creation failed');
      }
    } catch (err) {
      //toast.error(err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
        <BreadcrumbsWrapper
                                                    items={[
                                                      { label: 'Dashboard', path: '/dashboard' },
                                                      { label: 'Tags', path: '/tags' },
                                                      { label: 'CreateTags', path: '' },
                                                    
                                                     
                                                    ]}
                                                  />
                                            <br></br>
      <div className="page-header">
        <h1 className="mt-0">Add New Tag</h1>
      </div>

      <div className="page-top-formview mb-3">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="type">
              <Form.Label>Type</Form.Label>
              <Form.Control
                type="text"
                {...register('type', { required: 'Type is required' })}
                isInvalid={!!errors.type}
                readOnly 
              />
              <Form.Control.Feedback type="invalid">
                {errors.type?.message}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Name of tag"
                {...register('name', { required: 'Name is required' })}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>

          <Stack direction="row" spacing={2}>
            <Button variant="outlined" color="inherit" type="button" onClick={() => navigate('/tags')}>
              Cancel
            </Button>
            <Button variant="contained" className='red-bg red-button text-capitalize' type="submit" disabled={loading}>
              {loading ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
            </Button>
          </Stack>
        </Form>
      </div>
    </>
  );
}
